/*
 * @Author: Merlin
 * @Date: 2024-07-31 14:01:42
 * @LastEditors: Merlin
 * @LastEditTime: 2024-11-07 16:14:44
 * @Description: 
 */ 
import { oLongShort, } from './wavesData';
import { useCountdown } from './wavesFn';
let loadingTimer = null; 

export const oMethods = { 
    useCountdown,
    
    // 做为 range-change-handler 下发给子组件 
    rangeChangeHandler(oInfo, iMark=0){
        const oThis = (this as any);
        const {chartState, getPairHistory} = oThis.oChartStateToolbox;
        // 节流 
        if (chartState.historyLoading){
            clearTimeout(loadingTimer);
            loadingTimer = setTimeout(()=>{
                oThis.rangeChangeHandler(oInfo);
            }, 100);
            return;
        }
        const iFrom = ~~oInfo?.from;
        const bExecutable = (
            // ↓ 此处的值 < 10 说明再左侧无数据了，需要现在查询数据 
            oInfo && oInfo.from < 10
        );
        const toPrint = (
            (1 && import.meta.dev)
            // && iMark===2
            && iFrom % 21 === 0 
        );
        if (toPrint){
            console.log('From to:', iFrom, '-', ~~oInfo?.to, '锁定？=>', chartState.historyLoading); 
        }
        // console.log('向左侧追加数据的判断结果：', bExecutable.map(Number).join(',')); 
        if (bExecutable == false) return; 
        0 && console.log("开始查询左侧数据：", '💥🎯'); 
        getPairHistory({
            rangeMs: chartState.selectedTick,
            pair: chartState.selectedPair,
            data: chartState.data[0]?.time ?? void 0,
        });
    },
    // ↓ 监听右键窗口尺寸变化  
    watchRightPanelResize(){
        const oThis = (this as any);
        const {tradingController, leftHeader} = oThis.$refs; 
        if (!tradingController || !leftHeader) {
            return; 
        }
        oThis.iPanelHeight = tradingController.offsetHeight; 
        let timer01 = null;
        const observer02 = new ResizeObserver((aEntries) => {
            clearTimeout(timer01);
            timer01 = setTimeout(()=>{
                for (const oEntry of aEntries) {
                    oThis.iPanelHeight = (
                        oEntry.borderBoxSize?.[0].blockSize 
                        || oEntry.target['offsetHeight'] 
                    ); 
                }
            }, 100); 
        });
        observer02.observe(tradingController);
    },
    // ↓ 切换下注模式买涨/买跌 
    changeBetMode(sMode, bNewVal){
        const oThis = (this as any);
        if (!bNewVal){ 
            if (oThis.oForm.positionType == sMode){
                // ↓ 清除下注模式 
                oThis.oForm.positionType = '';
                // ↓ 重置表单数据 
                oThis.$refs.profitLossSetting.clearFormData(); 
            }
            return; 
        } 
        if (sMode === oLongShort.long){
            oThis.oForm.positionType = oLongShort.long;
            oThis.checkboxShort = false; 
            oThis.checkboxLong = true; // 多余，保留用于容错 
        }else if (sMode === oLongShort.short){ 
            oThis.oForm.positionType = oLongShort.short; 
            oThis.checkboxLong = false; 
            oThis.checkboxShort = true; // 多余，保留用于容错 
        }
        console.log("当前模式：", oThis.oForm.positionType); 
    },
    // ↓ 执行建仓 
    createPotiion(sLongShort){
        const oThis = (this as any);
        // console.log("sLongShort", sLongShort); 
        oThis.oPositionCenter.createPosition({
            type: sLongShort,
        });
    },
};



